import React from 'react'
import ReactPlayer from 'react-player'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import cloudinary from 'utils/cloudinary'
import RichTextContent from 'components/RichTextContent/RichTextContent'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'
import { StyledBlock, StyledCol } from './ProHomePageContentStyle'

const AppInfoBlock = ({ translate }) => (
  <Container>
    <StyledBlock>
      <Row hasVerticalAlign padding="sm" mdPadding="vertical-lg">
        <StyledCol sm="12" md="8" offset="2">
          <Title headingLevel="2" align="center">
            {translate('propage.block4.title')}
          </Title>
        </StyledCol>
        <Col sm="12" md="5" margin="top-md" mdMargin="null">
          <RichTextContent content={translate('propage.block4.text')} />
          <Row padding="top-md">
            <UniverseLink
              id="app-store-link"
              href="https://apps.apple.com/fr/app/quotatis/id1453572459"
            >
              <Image
                src={cloudinary('/vitrine/image/app-store_fr.png')}
                size="lg"
                margin="right-sm"
                alt={translate('alt.pro.app-ios')}
              />
            </UniverseLink>
            <UniverseLink
              id="google-store-link"
              href="https://play.google.com/store/apps/details?id=fr.quotatispro.quotatis"
            >
              <Image
                src={cloudinary('/vitrine/image/google-play-store_fr.png')}
                size="lg"
                alt={translate('alt.pro.app-android')}
              />
            </UniverseLink>
          </Row>
        </Col>
        <Col sm="12" md="6" offset="1">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=YfB1LIVTyYM"
            width="100%"
            height="315px"
          />
        </Col>
      </Row>
    </StyledBlock>
  </Container>
)

AppInfoBlock.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(AppInfoBlock)
